import { useEffect, useState, useRef } from 'react';
import { GoogleOAuthProvider, GoogleLogin } from '@react-oauth/google';
import { getGoogleLoginConfiguration } from '../../api/login';

export const GoogleSignIn = ({ disabled, onCredential, reset = 0 }) => {
  const container = useRef(null);
  const [width, setWidth] = useState(240);
  useEffect(() => {
    const measure = () => setWidth(Math.max(200, Math.min(400, Math.floor(container.current?.getBoundingClientRect().width || 240))));
    measure();
    const observer = typeof ResizeObserver !== 'undefined' ? new ResizeObserver(measure) : null;
    if (container.current) observer?.observe(container.current);
    window.addEventListener('resize', measure);
    return () => { observer?.disconnect(); window.removeEventListener('resize', measure); };
  }, []);
  const [configuration, setConfiguration] = useState(null);
  const [error, setError] = useState('');
  const [attempt, setAttempt] = useState(0);
  useEffect(() => {
    let active = true; setConfiguration(null); setError('');
    getGoogleLoginConfiguration().then(result => {
      if (!active) return;
      if (result?.error !== false) setError('No se pudo preparar Google.');
      else setConfiguration(result.data);
    }).catch(() => { if (active) setError('No se pudo preparar Google.'); });
    return () => { active = false; };
  }, [attempt, reset]);
  return <div ref={container} className="eats-google-access" aria-busy={disabled || (!configuration && !error)}>
    {configuration?.enabled && !error ? <fieldset inert={disabled ? "" : undefined} disabled={disabled} className="eats-google-control">
      <GoogleOAuthProvider clientId={configuration.clientId} onScriptLoadError={() => setError('No se pudo cargar Google.')}>
        <GoogleLogin key={configuration.nonce} nonce={configuration.nonce} auto_select={false} useOneTap={false} text="continue_with" shape="pill" size="large" locale="es" width={String(width)} onSuccess={result => { if (!disabled) onCredential(result.credential); }} onError={() => setError('No se pudo iniciar sesión con Google.')} />
      </GoogleOAuthProvider>
    </fieldset> : <button type="button" className="eats-google-placeholder" disabled>Continuar con Google</button>}
    {configuration?.enabled === false && <p className="eats-google-note">El acceso con Google aún no está disponible en esta tienda.</p>}
    {!configuration && !error && <p className="eats-google-note" role="status">Preparando Google…</p>}
    {error && <div role="alert" className="eats-google-note">{error} <button type="button" disabled={disabled} onClick={() => setAttempt(value => value + 1)}>Reintentar</button></div>}
    <div className="eats-auth-divider"><span>o continúa con tu email</span></div>
  </div>;
};
